import { render, staticRenderFns } from "./OrderShowDetail.vue?vue&type=template&id=5d456aee&"
import script from "./OrderShowDetail.vue?vue&type=script&lang=js&"
export * from "./OrderShowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports